import React from 'react';
import { bonuses } from '../data/modules';
export function BonusSection() {
  return <section className="bg-white px-4 py-4" data-id="element-19" data-mp="1og3zh07r0h54">
      <div className="mx-auto max-w-3xl" data-id="element-20" data-mp="1ofc3vpe5ijeu">
        <h2 className="mb-2.5 text-center font-display text-[21px] leading-tight text-ev-black sm:text-3xl" data-id="element-21" data-mp="22fn0l9256s7x">
          🎁 5 Professional Bonuses Included
        </h2>
        <ul className="space-y-2" data-id="element-22" data-mp="1yet7805xkl7n">
          {bonuses.map(bonus => <li key={bonus.number} data-id="element-23" data-mp="1apidh2mzzr30">
              <article className="rounded-lg border-2 border-dashed border-ev-green bg-ev-paper p-3" data-id="element-24" data-mp="1amct20pbdddm">
                <h3 className="font-cond text-[17px] leading-snug tracking-wide text-ev-black sm:text-xl" data-id="element-25" data-mp="15njbnx6wp286">
                  🎁 Bonus {bonus.number} — {bonus.title}
                </h3>
                <p className="mb-1 text-[12px] font-bold uppercase tracking-wide text-[#2E7D46] sm:text-[13px]" data-id="element-26" data-mp="1eor6u6e4lmy1">
                  {bonus.subtitle}
                </p>
                <p className="text-[13px] font-medium leading-snug text-ev-black/75 sm:text-[15px]" data-id="element-27" data-mp="mxtljne394ml">
                  {bonus.body}
                </p>
                <p className="mt-1 font-cond text-[14px] uppercase tracking-wide text-ev-black sm:text-base" data-id="element-28" data-mp="2er68b189rzk7">
                  {bonus.tagline}
                </p>
              </article>
            </li>)}
        </ul>
      </div>
    </section>;
}